export default "__VITE_ASSET__CiG9pYNb__"